import { TradeMode } from '@flipster/apis/v2/trade/types';
import segment from '@flipster/utils/segment';
import { ButtonText, PositionEvent } from '@flipster/utils/segment/events/position';
import { V2OrderSideType, V2SpotOrderSideType } from '@flipster/utils/types/base';

interface PositionProp {
  symbol: string;
  side: V2OrderSideType | V2SpotOrderSideType;
  initLeverage?: number;
  unrealizedPnl?: string;
  calcUnrealizedPnlPercent?: string;
  fundsInvested: string;
  isShowAll: boolean;
  mode: TradeMode;
  isProfitBoostMode: boolean;
  airdropType?: string | null;
}

export const fireYourPositionsManageClickEvent = (text: ButtonText, p: PositionProp) => {
  segment.track(PositionEvent.YourPositionsManageClickEvent, {
    button_text: text,
    symbol: p.symbol,
    side: p.side === 'Long' || p.side === 'Buy' ? 'buy' : 'sell',
    leverage: p.initLeverage ?? 1, // 1 for spot
    unrealized_pnl: p.unrealizedPnl ? Number(p.unrealizedPnl) : null,
    unrealized_pnl_percentage: p.calcUnrealizedPnlPercent ? Number(p.calcUnrealizedPnlPercent) : null,
    margin_usdt: Number(p.fundsInvested),
    position_mode: p.mode === 'OneWay' ? 'oneway' : 'multiposition',
    is_show_all: p.isShowAll,
    profit_boost_mode: p.isProfitBoostMode,
    is_airdrop: Boolean(p.airdropType),
  });
};
